import {createAxiosClient} from "./axiosClientFactory";
import AppSettings         from "../common/app-settings";

const isDevBackEnd = AppSettings.useDevBackEnd;
// todo: move this to env vars
let baseUrlDev = "https://rg0r8mmkeb.execute-api.us-east-2.amazonaws.com/dev";
let baseUrlProd = "https://jzbyhg3tog.execute-api.us-east-2.amazonaws.com/prod";
let baseUrl = isDevBackEnd ? baseUrlDev : baseUrlProd;

let xApiKeyDev = process.env.REACT_APP_SECRET_KEY_FOR_BACKEND_DEV;
let xApiKeyProd = process.env.REACT_APP_XAPIKEY;
let xApiKey = isDevBackEnd ? xApiKeyDev : xApiKeyProd;

const apiClient = createAxiosClient(baseUrl, xApiKey);

export default apiClient;